import CryptoJS from "crypto-js";

/**
 * Tạo code verifier ngẫu nhiên (43 ký tự, chữ hoa, chữ thường, số)
 */
export function generateCodeVerifier(): string {
  const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  let codeVerifier = "";
  
  for (let i = 0; i < 43; i++) {
    codeVerifier += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  
  return codeVerifier;
}

/**
 * Tạo code challenge từ code verifier
 * code_challenge = Base64.encode(SHA-256.hash(ASCII(code_verifier))) without padding
 */
export function generateCodeChallenge(codeVerifier: string): string {
  // Hash SHA-256 của code verifier (crypto-js tự động xử lý ASCII)
  const hash = CryptoJS.SHA256(codeVerifier);
  
  // Chuyển hash WordArray thành Base64 string
  const base64 = hash.toString(CryptoJS.enc.Base64);
  
  // Loại bỏ padding (=) ở cuối để đảm bảo Base64 without padding
  return base64.replace(/=+$/, "").replace(/\+/g, "-").replace(/\//g, "_");
}

/**
 * Lưu code verifier vào sessionStorage với state
 */
export function saveCodeVerifier(state: string, codeVerifier: string): void {
  sessionStorage.setItem(`zalo_pkce_${state}`, codeVerifier);
}

/**
 * Lấy code verifier từ sessionStorage bằng state
 */
export function getCodeVerifier(state: string): string | null {
  return sessionStorage.getItem(`zalo_pkce_${state}`);
}

/**
 * Xóa code verifier sau khi sử dụng
 */
export function removeCodeVerifier(state: string): void {
  sessionStorage.removeItem(`zalo_pkce_${state}`);
}

/**
 * Tạo state ngẫu nhiên để xác định authorization code
 */
export function generateState(): string {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

